import { render, staticRenderFns } from "./AdminRunDetailsPage.vue?vue&type=template&id=7ff98c30"
import script from "./AdminRunDetailsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminRunDetailsPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports